<template>
    <div>下载中...</div>
</template>
<script>
import axios from "axios"
export default {
    data() {
        return {

        }
    },
    methods: {
        down() {
            var query = this.$route.query;
            let url = query.url;
            let name = query.name + '.mp4';
            axios({
                method: 'get',
                url: url,
                responseType: 'blob'
            }).then((res) => {
                if ('download' in document.createElement('a')) {
                    let url = window.URL.createObjectURL(res.data);
                    let link = document.createElement('a');
                    link.style.display = 'none';
                    link.href = url;
                    link.setAttribute('download', name);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    navigator.msSaveBlob(res.data, name)
                }
                // this.$message.success("正在下载");
                window.close()
            }).catch(err => {
                alert(name + "下载失败");
                console.log(err);
            })
        }
    },
    created() {
        this.down();

    }

}
</script>
